export type EnvironmentName = 'development' | 'test' | 'uat' | 'production';

export const DEV_ENV = 'development';
export const TEST_ENV = 'test';
export const UAT_ENV = 'uat';
export const UAT2_ENV = 'uat2';
export const PROD_ENV = 'production';

export const NON_PROD_ENV: readonly string[] = [
   DEV_ENV,
   TEST_ENV,
   UAT_ENV,
   UAT2_ENV
   
] as EnvironmentName[];
